/* bk-basket.js — fiche BASKET portee sur SAVUYA le 25/10/2026.
   Adapte de site-maquette/js/app.js. Ne garde QUE ce que la fiche doit faire :
   galerie, accordeons, pack + tiroir de taille -> VARIANTE SHOPIFY, un couple
   prenom/numero par exemplaire, apercu, CTA collant mobile.
   🔑 AUCUN PRIX N'EST ECRIT ICI : ils viennent du JSON #bk-variantes, qui vient
      des 6 variantes Shopify. Prix affiche = prix encaisse, par construction.
   🔑 Le radio et les champs restent la SEULE source de verite (lecon SONALYA
      du 10/09) : le JS pose/retire `hidden` et `disabled`, il ne duplique rien. */
(function () {
  'use strict';
  var R = document.getElementById('bk-page');
  if (!R) return;
  var $  = function (s, r) { return (r || R).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || R).querySelectorAll(s)); };
  var MAX_NOM = 12, MAX_NUM = 99;

  var VAR = [];
  try { VAR = JSON.parse(document.getElementById('bk-variantes').textContent); } catch (e) {}
  if (!VAR.length) return;

  /* Le filtre `money` de Shopify peut rendre des entites HTML (&nbsp; pour un prix
     en euros, p. ex.). Dans un <script type="application/json"> le parseur HTML ne
     les decode PAS : on les decode une fois ici, sinon « 69,99&nbsp;€ » s'afficherait
     tel quel. */
  var _dec = document.createElement('textarea');
  function dec(x) { if (!x) return ''; _dec.innerHTML = x; return _dec.value; }
  VAR.forEach(function (v) {
    v.prix_f = dec(v.prix_f); v.barre_f = dec(v.barre_f);
    v.unite_f = dec(v.unite_f); v.eco_f = dec(v.eco_f);
  });

  /* ⛔ AUCUN MONTANT N'EST CALCULE NI PREFIXE ICI : toutes les chaines de prix
     viennent du filtre `money` de Shopify (voir le JSON #bk-variantes). */
  function tailleActive() { var r = $('input[name="bk-taille"]:checked'); return r ? r.value : 'xl'; }
  function packActif()    { var r = $('input[name="bk-pack"]:checked');  return r ? parseInt(r.value, 10) : 1; }
  function nomTaille(v)   { return v === 'small' ? 'Small' : 'XL'; }
  function variante(taille, n) {
    for (var i = 0; i < VAR.length; i++)
      if (VAR[i].taille === nomTaille(taille) && VAR[i].pack === n) return VAR[i];
    return null;
  }

  /* ------------------------------------------------------------- 1. GALERIE
     ⚠️ La piste est un carrousel a DEFILEMENT (overflow-x:auto + scroll-snap),
     PAS un translateX. Code repris VERBATIM de la maquette : un transform
     entrerait en conflit avec le scroll-snap du CSS porte. */
  var piste = $('[data-piste]'), cpt = $('[data-gal-cpt]'), vigns = $$('[data-vign] button');
  function nbDias() { return $$('.gal__dia', piste).length; }
  function indexCourant() {
    if (!piste) return 0;
    var l = piste.clientWidth || 1;
    return Math.min(nbDias() - 1, Math.max(0, Math.round(piste.scrollLeft / l)));
  }
  function majGalerie() {
    var i = indexCourant();
    if (cpt) cpt.textContent = (i + 1) + ' / ' + nbDias();
    vigns.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
  }
  function vaVers(i) {
    if (!piste) return;
    i = Math.max(0, Math.min(nbDias() - 1, i));
    piste.scrollTo({ left: i * piste.clientWidth, behavior: 'smooth' });
  }
  if (piste) {
    var tmo = null;
    piste.addEventListener('scroll', function () { clearTimeout(tmo); tmo = setTimeout(majGalerie, 90); });
    $$('[data-gal]').forEach(function (b) {
      b.addEventListener('click', function () { vaVers(indexCourant() + parseInt(b.dataset.gal, 10)); });
    });
    vigns.forEach(function (b, k) { b.addEventListener('click', function () { vaVers(k); }); });
    majGalerie();
  }

  /* -------------------------------------------- 1 bis. ZOOM PLEIN ECRAN (LOT 860)
     Ammar, 30/10 : « faire glisser avec le doigt, taper sur la photo pour le zoom ».
     Mesure du 30/10 en prod : un tap sur la photo ne faisait RIEN (pas d'ancre, pas de
     bouton, cursor:auto, DOM identique avant/apres) => Clarity comptait 6 « clics morts »
     et des rage clicks sur la photo en UNE visite venue de la pub.
     🔑 Le <dialog> est construit A LA PREMIERE OUVERTURE et l'image pleine resolution
        (data-zm, 1254 px) n'est demandee qu'a ce moment : 0 octet avant le LCP, qui a
        ete descendu de 7 196 a 5 412 ms le 29/10 et ne doit pas bouger.
     🔑 Le dialogue est ajoute DANS #bk-page : le CSS reste scope, rien ne fuite.
     ⛔ Aucune librairie, aucun CDN tiers. */
  var zDlg = null, zImg = null, zCpt = null, zI = 0, zX2 = false, zOvf = '';
  function zDias() { return piste ? $$('.gal__dia img', piste) : []; }
  function zX2off() { zX2 = false; if (zImg) { zImg.classList.remove('zm__img--x2');
    zImg.style.transformOrigin = ''; zImg.style.cursor = 'zoom-in'; } }
  function zBascule(e) {
    zX2 = !zX2;
    if (zX2) { var r = zImg.getBoundingClientRect();
      zImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% '
                                 + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
      zImg.classList.add('zm__img--x2'); zImg.style.cursor = 'zoom-out'; }
    else { zX2off(); }
  }
  function zMontre(i) {
    var L = zDias(); if (!L.length || !zImg) return;
    zI = Math.max(0, Math.min(L.length - 1, i));
    zX2off();
    /* data-zm = pleine resolution. Repli sur ce que la diapo affiche deja si absent. */
    zImg.setAttribute('src', L[zI].getAttribute('data-zm') || L[zI].currentSrc || L[zI].src);
    zImg.setAttribute('alt', L[zI].getAttribute('alt') || '');
    if (zCpt) zCpt.textContent = (zI + 1) + ' / ' + L.length;
  }
  function zGo(d) { zMontre(zI + d); }
  function zFerme() {
    if (!zDlg) return;
    if (zDlg.close && zDlg.open) zDlg.close();
    else { zDlg.removeAttribute('open'); zDlg.removeAttribute('aria-modal'); }
    document.documentElement.style.overflow = zOvf;   /* restitution a l'identique */
    vaVers(zI);                                       /* la galerie suit la photo vue */
  }
  function zConstruit() {
    if (zDlg) return zDlg;
    zDlg = document.createElement('dialog');
    zDlg.className = 'zm';
    zDlg.setAttribute('aria-label', 'Product photo, full screen');
    zDlg.innerHTML =
      '<button class="zm__x" type="button" aria-label="Close">✕</button>'
    + '<button class="zm__fl zm__fl--p" type="button" data-zm-go="-1" aria-label="Previous photo">‹</button>'
    + '<img class="zm__img" alt="" decoding="async">'
    + '<button class="zm__fl zm__fl--s" type="button" data-zm-go="1" aria-label="Next photo">›</button>'
    + '<span class="zm__cpt"></span>';
    R.appendChild(zDlg);
    zImg = $('.zm__img', zDlg); zCpt = $('.zm__cpt', zDlg);
    $('.zm__x', zDlg).addEventListener('click', function (e) { e.stopPropagation(); zFerme(); });
    $$('[data-zm-go]', zDlg).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation();
        zGo(parseInt(b.getAttribute('data-zm-go'), 10)); });
    });
    zDlg.addEventListener('click', function (e) { if (e.target === zDlg) zFerme(); });  /* le fond */
    zDlg.addEventListener('cancel', function (e) { e.preventDefault(); zFerme(); });    /* Echap */
    /* tap sur l'image = bascule x2 ; glissement = photo suivante / precedente */
    var sx = 0, sy = 0, bouge = false;
    zImg.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; bouge = false; });
    zImg.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - sx) > 12 || Math.abs(e.clientY - sy) > 12) bouge = true; });
    zImg.addEventListener('pointerup', function (e) {
      var dx = e.clientX - sx;
      if (bouge) { if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(e.clientY - sy)) zGo(dx < 0 ? 1 : -1); return; }
      zBascule(e);
    });
    return zDlg;
  }
  function zOuvre(i) {
    zConstruit();
    zMontre(typeof i === 'number' && i >= 0 ? i : indexCourant());
    if (zDlg.showModal) { try { zDlg.showModal(); } catch (e) { zDlg.setAttribute('open', ''); } }
    else { zDlg.setAttribute('open', ''); zDlg.setAttribute('aria-modal', 'true'); }
    zOvf = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
  }
  if (piste) {
    /* Garde-fou : un GLISSEMENT ne doit pas ouvrir le zoom. On ne retient que les taps
       dont le pointeur a bouge de moins de 10 px. */
    var pbx = 0, pby = 0, pbouge = false;
    piste.addEventListener('pointerdown', function (e) {
      pbx = e.clientX; pby = e.clientY; pbouge = false; }, { passive: true });
    piste.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - pbx) > 10 || Math.abs(e.clientY - pby) > 10) pbouge = true;
    }, { passive: true });
    piste.addEventListener('click', function (e) {
      var m = e.target && e.target.closest ? e.target.closest('.gal__dia img') : null;
      if (!m || pbouge) return;
      zOuvre(zDias().indexOf(m));
    });
    var bzm = $('[data-zoom-ouvre]');
    if (bzm) bzm.addEventListener('click', function (e) { e.stopPropagation(); zOuvre(indexCourant()); });
  }

  /* --------------------------------------------------------- 2. ACCORDEONS */
  $$('[data-acc]').forEach(function (b) {
    b.addEventListener('click', function () {
      var o = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', o ? 'false' : 'true');
      var c = b.nextElementSibling;
      if (c) c.classList.toggle('on', !o);
    });
  });

  /* ---------------------------------- 3. TAILLE + PACK -> VARIANTE SHOPIFY
     Logique reprise VERBATIM de la maquette (validee par Ammar le 25/10) :
     • les 6 radios de taille partagent le MEME name => le navigateur garantit
       seul qu'une seule taille est cochee dans la page ; aucun etat duplique.
     • le tiroir de taille s'ouvre DANS la carte du pack coche.
     • `void tir.offsetHeight` : lecture de mise en page forcee, sans elle la
       transition depuis display:none ne part pas (lecon du 25/10).
     Seule difference : les PRIX ne viennent plus d'une constante JS mais des
     VARIANTES SHOPIFY, donc de ce que la caisse encaisse. */
  function poseTailles() {
    $$('[data-taille]').forEach(function (carte) {
      var n = 1, pc = carte.closest('[data-pack]');
      if (pc) { var r = $('input[name="bk-pack"]', pc); if (r) n = parseInt(r.dataset.n, 10); }
      var v = variante(carte.dataset.taille, n); if (!v) return;
      $('[data-tl-prix]',  carte).textContent = v.prix_f;
      $('[data-tl-vieux]', carte).textContent = v.barre_f;
      var inp = $('input', carte);
      if (inp) inp.setAttribute('aria-label', $('[data-tl-nom]', carte).textContent +
        ' — ' + $('[data-tl-dim]', carte).textContent + ' — ' + v.prix_f);
    });
  }

  var tiroirDejaRendu = false;
  function majTiroirs() {
    var choisi = $('input[name="bk-pack"]:checked');
    $$('[data-pack]').forEach(function (carte) {
      var tir = $('[data-tiroir-taille]', carte);
      if (!tir) return;
      var actif = choisi && carte.contains(choisi);
      if (!actif) { tir.classList.remove('on'); tir.hidden = true; return; }
      if (tir.hidden) { tir.hidden = false; if (tiroirDejaRendu) { void tir.offsetHeight; } }
      tir.classList.add('on');
    });
    tiroirDejaRendu = true;
  }

  function syncTaille() {
    var ch = $('input[name="bk-pack"]:checked');
    var carte = ch && ch.closest('[data-pack]');
    if (!carte) return;
    var v = tailleActive();
    var r = $('input[name="bk-taille"][value="' + v + '"]', carte);
    if (r && !r.checked) r.checked = true;
  }

  function majPrix() {
    var t = tailleActive();
    $$('[data-pack]').forEach(function (carte) {
      var r = $('input[name="bk-pack"]', carte); if (!r) return;
      var n = parseInt(r.dataset.n, 10), v = variante(t, n); if (!v) return;
      $('[data-pk-total]', carte).textContent = v.prix_f;
      $('[data-pk-vieux]', carte).textContent = v.barre_f;
      $('[data-pk-unite]', carte).textContent = v.unite_f + ' / mirror';
    });
    poseTailles();
    var v = variante(t, packActif()); if (!v) return;
    $('[data-prix-aff]').textContent   = v.prix_f;
    $('[data-prix-vieux]').textContent = v.barre_f;
    $('[data-prix-eco]').textContent   = v.eco_f ? 'Save ' + v.eco_f : '';
    var h = $('[data-bk-vid]'); if (h) h.value = v.id;   // LA variante envoyee au panier
  }

  /* --------------------- 4. UN COUPLE DE CHAMPS PAR EXEMPLAIRE */
  function nettoieNom(v) { return v.toUpperCase().replace(/[^A-Z0-9 .'-]/g, '').slice(0, MAX_NOM); }
  function nettoieNum(v) {
    v = v.replace(/\D/g, '').slice(0, 2);
    if (v !== '' && parseInt(v, 10) > MAX_NUM) v = String(MAX_NUM);
    return v;
  }
  function err(input, on) {
    var e = $('[data-err="' + input.id + '"]');
    if (e) e.classList.toggle('on', !!on);
    input.setAttribute('aria-invalid', on ? 'true' : 'false');
  }
  function majApercu() {
    for (var i = 1; i <= 3; i++) {
      var n = $('#bk-nom' + i), u = $('#bk-num' + i);
      var cn = $('[data-ap-nom="' + i + '"]'), cu = $('[data-ap-num="' + i + '"]');
      if (cn) cn.textContent = (n && n.value) ? n.value : '—';
      if (cu) cu.textContent = (u && u.value) ? u.value : '—';
    }
  }
  function majPaires() {
    var n = packActif();
    for (var i = 1; i <= 3; i++) {
      var bloc = $('[data-paire="' + i + '"]'), it = $('[data-ap-it="' + i + '"]');
      var actif = (i <= n);
      if (bloc) {
        bloc.hidden = !actif;
        [$('#bk-nom' + i), $('#bk-num' + i)].forEach(function (c) {
          if (!c) return;
          if (actif) { c.disabled = false; c.setAttribute('required', ''); }
          // AJOUT POUR SHOPIFY : un champ masque est DESACTIVE, sinon sa propriete
          // partirait vide dans la ligne de panier (« Mirror 3 name : »).
          else { c.disabled = true; c.removeAttribute('required'); err(c, false); }
        });
      }
      if (it) it.hidden = !actif;
    }
    var g = $('[data-ap-g]');
    if (g) g.className = 'apercu__g apercu__g--' + n;
  }
  for (var k = 1; k <= 3; k++) {
    (function (k) {
      var nom = $('#bk-nom' + k), num = $('#bk-num' + k);
      if (!nom || !num) return;
      nom.addEventListener('input', function () {
        var p = nom.selectionStart; nom.value = nettoieNom(nom.value);
        try { nom.setSelectionRange(p, p); } catch (e) {}
        err(nom, false); majApercu();
      });
      num.addEventListener('input', function () {
        num.value = nettoieNum(num.value); err(num, false); majApercu();
      });
    })(k);
  }

  /* -------------------------------------------- 5. BRANCHEMENTS */
  R.addEventListener('change', function (e) {
    if (!e.target || !e.target.name) return;
    if (e.target.name === 'bk-taille') { majPrix(); }
    if (e.target.name === 'bk-pack') { majTiroirs(); syncTaille(); majPrix(); majPaires(); majApercu(); }
  });

  /* ------------------------------------------------ 6. ENVOI AU PANIER */
  var form = $('[data-bk-form]');
  if (form) form.addEventListener('submit', function (e) {
    var n = packActif(), ko = null;
    for (var k = 1; k <= n; k++) {
      var nom = $('#bk-nom' + k), num = $('#bk-num' + k);
      if (nom && !nom.value.trim()) { err(nom, true); ko = ko || nom; }
      if (num && !num.value.trim()) { err(num, true); ko = ko || num; }
    }
    /* lot 983 : `stopPropagation` en plus de `preventDefault`. Le composant d'ajout du
       theme ecoute `submit` sur `product-form-component`, donc EN AMONT dans la phase de
       bouillonnement : sans l'arret, un champ vide etait bien signale a l'ecran mais
       l'article partait quand meme au panier. */
    if (ko) { e.preventDefault(); e.stopPropagation(); ko.scrollIntoView({ block: 'center', behavior: 'smooth' }); ko.focus(); return; }
    /* lot 986 : LE TIROIR S'OUVRE MAINTENANT, IL SE REMPLIT ENSUITE.
       Mesure du 26/10 avant correctif : clic -> tiroir peint = 650-771 ms (Chromium) et
       719-1460 ms (WebKit), parce que `cart-drawer.js` refuse l'ouverture immediate quand le
       panier est VIDE (`!this.#isCartEmpty()`), donc attend /cart/add.js PUIS /cart.json.
       On ouvre nous-memes des que la validation passe. Le theme, lui, voit ensuite le tiroir
       deja ouvert : son `shouldAutoOpen` tombe a faux, pas de double ouverture, et son
       `settle()` recalcule le resume collant quand le contenu arrive. */
    ouvreTiroirTouteSuite();
  });

  function ouvreTiroirTouteSuite() {
    var td = document.querySelector('theme-drawer#cart-drawer');
    if (!td) return;
    /* on respecte le reglage du theme : si l'ouverture auto est desactivee, on ne l'impose pas */
    if (!td.querySelector('cart-drawer-component[auto-open]')) return;
    if (td.hasAttribute('open')) return;

    var vide = !!td.querySelector('.cart-drawer--empty');
    if (vide) td.setAttribute('data-bk-chargement', '');

    var ouvre = function () {
      try { if (typeof td.open === 'function') { td.open(); return; } } catch (err) {}
      td.setAttribute('open', '');
    };
    if (window.customElements && !customElements.get('theme-drawer')) {
      customElements.whenDefined('theme-drawer').then(ouvre);
    } else {
      ouvre();
    }
    if (!vide) return;

    var fini = false;
    var devoile = function () {
      if (fini) return; fini = true;
      obs.disconnect();
      td.removeAttribute('data-bk-chargement');
    };
    var obs = new MutationObserver(function () {
      if (!td.querySelector('.cart-drawer--empty')) devoile();
    });
    obs.observe(td, { childList: true, subtree: true, attributes: true });
    /* filet : au-dela de 10 s l'ajout a echoue (rupture, limite de quantite, reseau) ;
       on devoile, et on referme pour ne pas laisser un tiroir vide ouvert. */
    setTimeout(function () {
      var toujoursVide = !!td.querySelector('.cart-drawer--empty');
      devoile();
      if (toujoursVide && typeof td.close === 'function') { try { td.close(); } catch (err) {} }
    }, 10000);
  }

  /* ----------------------------------------- 7. CTA COLLANT MOBILE */
  var sticky = $('[data-sticky]'), barre = $('[data-sticky-barre]'), ancre = $('.achat');
  if (sticky && barre && ancre && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      barre.classList.toggle('on', !es[0].isIntersecting && window.scrollY > 120);
    }, { threshold: 0 }).observe(ancre);
    sticky.addEventListener('click', function () {
      var c = $('#bk-nom1');
      var p = $('.perso'); if (p) p.scrollIntoView({ block: 'center', behavior: 'smooth' });
      if (c) setTimeout(function () { c.focus(); }, 400);
    });
  }

  poseTailles(); majTiroirs(); syncTaille(); majPrix(); majPaires(); majApercu();
})();
